import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import config from 'constants/apiConfig';
import { useAppSelector } from 'slices/commonSelectors';
import { selectCombinedUser } from 'slices/commonSelectors';
import { toast } from 'react-toastify';
import { keys } from './useFetchExerciseWorkspaceTeamStatus';
import { MicrosoftTemplate } from 'types/template';

type GenerateExerciseWorkspaceTeamSiteInput = {
  workspaceId: UUID;
  template: MicrosoftTemplate;
  tenantId: UUID;
};

export const useGenerateExerciseWorkspaceTeamSite = () => {
  const queryClient = useQueryClient();
  const userId = useAppSelector(selectCombinedUser).user_guid;

  return useMutation<any, any, GenerateExerciseWorkspaceTeamSiteInput>({
    mutationFn: async ({ workspaceId, template, tenantId }) => {
      const response = await axios(config.apiGateway.generateTeamSite, {
        method: 'POST',
        data: {
          workspace_id: workspaceId,
          template,
          tenantId,
          user_id: userId,
        },
      });
      return response?.data;
    },
    onSuccess: ({ message, status }, { workspaceId }) => {
      if (status === 'In progress') {
        toast.success(message);
      }

      queryClient.invalidateQueries({
        queryKey: [keys.exerciseWorkspaceTeamStatus, workspaceId],
      });
    },
  });
};
